// extracted by mini-css-extract-plugin
export default {"wrapper":"directory-table_wrapper__qVENs","wrapperResizable":"directory-table_wrapperResizable__jQH5p"};